// src/pages/DynamicPage.tsx

import React from "react";
import { useParams } from "react-router-dom";
import { appData } from "../data/appData";
import PageConfigurator from "../components/PageConfigurator";
import NotFoundPage from "./NotFoundPage";
import { GeneralPageData } from "../types/interfaces";

const DynamicPage: React.FC = () => {
  const { pageType } = useParams<{ pageType: string }>();
  const publicDynamicPages = new Set(["solutions"]);

  const pageData = appData.pages[pageType as keyof typeof appData.pages];

  if (!pageType || !publicDynamicPages.has(pageType) || !pageData) {
    return <NotFoundPage />;
  }

  return (
    <PageConfigurator
      pageData={pageData as GeneralPageData}
      pageName={pageType as string}
    />
  );
};

export default DynamicPage;
